module.exports = __webpack_public_path__ + "static/img/16.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/16.png
// module id = Uh4E
// module chunks = 0